module.exports = __webpack_public_path__ + "media/images/promo/championship/02-d6c617b1019b68112dd8f3bcba250884.png";